<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $t('message.edit') }} {{ $tc('message.reasons', 1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <b-form @submit="onSubmit" @reset="onReset" v-if="show">
                    <b-row>
                        <b-col sm="3">
                        </b-col>
                        <b-col sm="6">
                            <b-form-group
                                    id="reference-group"
                                    :label="$t('message.reference')"
                                    label-for="reference"
                                    description=""
                            >
                                <b-form-input
                                        id="reference"
                                        v-model="$v.form.reference.$model"
                                        :state="$v.form.reference.$dirty ? !(errorshasField('reference') || $v.form.reference.$error) : null"
                                        required
                                        placeholder=""
                                        @focus="clearErrorField('reference')"
                                ></b-form-input>

                                <b-form-invalid-feedback v-if="!$v.form.reference.required">
                                    {{ $t('message.requiredField') }}
                                </b-form-invalid-feedback>

                                <b-form-invalid-feedback v-else-if="errorshasField('reference')">
                                    {{ getErrorsField('reference') }}
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                        <b-col sm="3">
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="3">
                        </b-col>
                        <b-col sm="6">
                            <b-form-group
                                    id="description-group"
                                    :label="$t('message.description')"
                                    label-for="description">
                                <b-form-textarea
                                        id="description"
                                        v-model="$v.form.description.$model"
                                        :state="$v.form.description.$dirty ? !(errorshasField('description') || $v.form.description.$error) : null"
                                        rows="5"
                                        required
                                        placeholder=""
                                        @focus="clearErrorField('description')"
                                ></b-form-textarea>

                                <b-form-invalid-feedback v-if="!$v.form.description.required">
                                    {{ $t('message.requiredField') }}
                                </b-form-invalid-feedback>

                                <b-form-invalid-feedback v-else-if="errorshasField('description')">
                                    {{ getErrorsField('description') }}
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                        <b-col sm="3">
                        </b-col>
                    </b-row>

                    <b-row class="justify-content-sm-center" v-if="can">
                        <b-button type="submit" variant="primary">
                            {{ $t('message.edit') }}
                        </b-button>

                    </b-row>
                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { required } from 'vuelidate/lib/validators';

    export default {
        name: "EditReason",

        computed: {
            ...mapGetters(["reason", "errors", "hasAdminRole", "hasMedecinControleRole", "hasPraticienRole","hasAssistante"]),

            form: function() {
                return this.reason;
            },

            can: function (){
                if (this.hasAdminRole){
                    return true;
                }else{
                    return this.hasMedecinControleRole || this.hasPraticienRole || this.hasAssistante;
                }
            }
        },

        data() {
            return {
                reason_slug: this.$route.params.reason,
                show: true
            }
        },

        methods: {
            getReason: function() {
                let args = {
                    motif: this.reason_slug
                };
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };

                this.$store.dispatch('getReason', { args, errorMessages });
            },

            onSubmit: function(evt) {
                evt.preventDefault();

                this.$v.$touch();

                if(!this.$v.$invalid) {
                    let args = {
                        motif: this.reason_slug,
                        reference: this.form.reference,
                        description: this.form.description
                    };

                    let successMessage = this.$i18n.t('message.reasonUpdated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };

                    this.$store.dispatch('updateReason', { args, errorMessages, successMessage })
                        .then(() => {
                            // Scroll to the top of the page
                            document.body.scrollTop = 0; // For Safari
                            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                        });
                }
            },

            onReset: function(evt) {
            },

            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },

            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },

            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });

                this.getErrorsField(field);
            }
        },

        validations: {
            form: {
                reference: {
                    required
                },
                description: {
                }
            }
        },

        mounted() {
            // Retrieve reason
            this.getReason();
        }
    }
</script>

<style scoped>

</style>